
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trademark-registration",
      function () {
        return require("private-next-pages/trademark-registration/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trademark-registration"])
      });
    }
  